import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { adminStatus } from "../../services/adminService";

const NAVY = "#2a2420";
const ORANGE = "#607840";

export default function PostAuthGate() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    adminStatus()
      .then((status) => {
        if (status.isPlatformAdmin && !status.verified) navigate("/admin/verify", { replace: true });
        else if (status.isPlatformAdmin && status.verified) navigate("/admin", { replace: true });
        else navigate("/", { replace: true });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [user, navigate]);

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "#fefcf8" }}
    >
      <div className="flex flex-col items-center gap-3">
        <Loader2 size={28} className="animate-spin" style={{ color: ORANGE }} />
        <p className="text-sm font-medium" style={{ color: NAVY, opacity: 0.55 }}>
          Loading your account…
        </p>
      </div>
    </div>
  );
}
